"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2595],{

/***/ 54171:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/dawn-logo.d6e5226b.svg","height":32,"width":107});

/***/ }),

/***/ 42385:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/navbar-get-started.e695b23d.svg","height":64,"width":177});

/***/ }),

/***/ 504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": function() { return /* reexport */ Link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/Link/Link.tsx




/* istanbul ignore file */ // @ts-nocheck
// WARNING: DO NOT EDIT THIS FILE UNLESS YOU ARE SURE ABOUT WHAT YOU ARE DOING. MIGHT CAUSE UNEXPECTED LINK ISSUES


var Link = function(_param) {
    var children = _param.children, href = _param.href, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    var router = (0,next_router.useRouter)();
    var hrefObj = {
        pathname: href.pathname || "",
        query: {}
    };
    if (typeof href === "string") {
        hrefObj.pathname = href;
    }
    if (href.query) {
        hrefObj.query = href.query;
    }
    var queries = {};
    Object.entries(router.query).forEach(function(q) {
        if (q[0].toLowerCase().includes("utm") || q[0].toLowerCase().includes("gclid")) {
            queries[q[0]] = q[1];
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: {
            pathname: hrefObj.pathname || href,
            query: (0,_object_spread/* default */.Z)({}, queries, hrefObj.query)
        }
    }, props), {
        children: children
    }));
};


;// CONCATENATED MODULE: ./components/Link/index.ts



/***/ }),

/***/ 92595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js
var popover = __webpack_require__(86215);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(504);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/dawn-logo.svg
var dawn_logo = __webpack_require__(54171);
;// CONCATENATED MODULE: ./components/Navbar/NavbarLogo.tsx




function NavbarLogo(param) {
    var _width = param.width, width = _width === void 0 ? 107 : _width;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
        href: "/",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            "aria-label": "Back to main page",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: dawn_logo/* default */.Z,
                alt: "Dawn logo",
                width: width
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/Navbar/NavbarLinks.tsx




function NavbarLinksDefault(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/pricing",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: classnames_default()(linkClassName, {
                        "font-bold": router.pathname === "/pricing"
                    }),
                    children: "Pricing"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/blog",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: classnames_default()(linkClassName, {
                        "font-bold": router.pathname.startsWith("/blog")
                    }),
                    children: "Blog"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/faq",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: classnames_default()(linkClassName, {
                        "font-bold": router.pathname.startsWith("/faq")
                    }),
                    children: "FAQ"
                })
            })
        ]
    });
}
var navbarLinksAboutPathnames = [
    "/company",
    "/reviews",
    "/employers"
];
function NavbarLinksAbout(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/company",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Company"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/reviews",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Reviews"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/employers",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Enterprise"
                })
            })
        ]
    });
}
var navbarLinksPagesPathnames = [
    "/insomnia-criteria",
    "/cbt-i-app",
    "/insomnia-cure",
    "/sleep-therapy"
];
function NavbarLinksPages(param) {
    var linkClassName = param.linkClassName, linkOnClick = param.linkOnClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/insomnia-criteria",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Insomnia Criteria"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/cbt-i-app",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "CBT-I App"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/sleep-therapy",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Sleep Therapy"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/primary-insomnia",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Primary Insomnia"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/chronic-insomnia",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Chronic Insomnia"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                href: "/insomnia-test",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: linkOnClick,
                    className: linkClassName,
                    children: "Insomnia Test"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/disclosure/disclosure.js
var disclosure = __webpack_require__(6512);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(84539);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/solid/esm/index.js + 230 modules
var esm = __webpack_require__(63153);
;// CONCATENATED MODULE: ./components/Navbar/NavbarMenuMobileDisclosure.tsx





function NavbarMenuMobileDisclosure(param) {
    var title = param.title, children = param.children, linkPathnames = param.linkPathnames;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pb-6 border-b border-white border-opacity-10",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
            children: function(param) {
                var open = param.open;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure.Button */.p.Button, {
                            className: "flex items-center justify-between w-full hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-dawnDark-500 focus-visible:ring-opacity-75",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classnames_default()("text-sm tracking-widest text-white uppercase", "".concat(open || linkPathnames.includes(router.asPath) ? "font-bold" : "font-medium")),
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ChevronUpIcon */.g8U, {
                                    className: "".concat(open ? "" : "transform rotate-180", " w-5 h-5")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                            show: open,
                            enter: "transition duration-100 ease-out",
                            enterFrom: "transform scale-95 opacity-0",
                            enterTo: "transform scale-100 opacity-100",
                            leave: "transition duration-75 ease-out",
                            leaveFrom: "transform scale-100 opacity-100",
                            leaveTo: "transform scale-95 opacity-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure.Panel */.p.Panel, {
                                static: true,
                                className: "flex flex-col mt-8 mb-4 space-y-8",
                                children: children
                            })
                        })
                    ]
                });
            }
        })
    });
}

;// CONCATENATED MODULE: ./components/Navbar/NavbarMenuMobile.tsx








function NavbarMenuMobile(param) {
    var ctaInHeader = param.ctaInHeader, ctaText = param.ctaText;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    (0,react.useEffect)(function() {
        document.body.classList.toggle("prevent-body-scroll", isOpen);
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
        children: function(param) {
            var open = param.open;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("flex items-center justify-between px-6 py-5", {
                    "bg-dawnDark-500 fixed inset-x-0 z-20": isOpen
                }),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {
                        width: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("pb-2", {
                            hidden: !ctaInHeader
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "/questionnaire",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center whitespace-nowrap",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    onClick: function() {
                                        return setIsOpen(false);
                                    },
                                    className: "flex items-center justify-center flex-1 max-w-md px-4 py-2 text-sm font-medium tracking-widest text-white uppercase whitespace-nowrap getStartedNavBar bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 rounded-3xl",
                                    children: ctaText !== null && ctaText !== void 0 ? ctaText : "Get started"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                className: "focus:outline-none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    onClick: function() {
                                        return setIsOpen(function(isOpen) {
                                            return !isOpen;
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                        className: "w-6 h-6",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        children: open ? /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M6 6L18 18M6 18L18 6L6 18Z",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                            d: "M3.9751 17.975H19.9751M3.9751 5.97501H19.9751H3.9751ZM3.9751 11.975H19.9751H3.9751Z",
                                            stroke: "white",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                                static: true,
                                className: classnames_default()("absolute inset-x-0 min-h-screen h-full z-20 bg-dawnDark-500", {
                                    hidden: !isOpen
                                }),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col justify-between h-full px-6 overflow-y-scroll",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col pt-6 space-y-6 text-sm text-white",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuMobileDisclosure, {
                                                    title: "About",
                                                    linkPathnames: navbarLinksAboutPathnames,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksAbout, {
                                                        linkOnClick: function() {
                                                            return setIsOpen(false);
                                                        },
                                                        linkClassName: "font-inter text-base font-normal"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuMobileDisclosure, {
                                                    title: "Our Science",
                                                    linkPathnames: navbarLinksPagesPathnames,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksPages, {
                                                        linkOnClick: function() {
                                                            return setIsOpen(false);
                                                        },
                                                        linkClassName: "font-inter text-base font-normal"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksDefault, {
                                                    linkOnClick: function() {
                                                        return setIsOpen(false);
                                                    },
                                                    linkClassName: "pb-6 border-b border-white border-opacity-10 uppercase tracking-widest font-medium"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("mt-6 mb-20", {
                                                hidden: ctaInHeader
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                                                href: "/questionnaire",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex justify-center",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        onClick: function() {
                                                            return setIsOpen(false);
                                                        },
                                                        className: "flex items-center justify-center flex-1 max-w-md px-8 py-4 text-sm font-medium tracking-widest text-white uppercase getStartedNavBar bg-gradient-to-tr from-dawnOrange-500 to-dawnPurple-500 rounded-3xl",
                                                        children: "Get started"
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-popper/lib/esm/usePopper.js + 53 modules
var usePopper = __webpack_require__(66441);
;// CONCATENATED MODULE: ./components/Navbar/NavbarMenuDesktopDropdown.tsx








function NavbarMenuDesktopDropdown(param) {
    var title = param.title, children = param.children, linkPathnames = param.linkPathnames;
    var router = (0,next_router.useRouter)();
    var popperElementRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(null), buttonElement = ref[0], setButtonElement = ref[1];
    var ref1 = (0,react.useState)(null), popperElement = ref1[0], setPopperElement = ref1[1];
    var ref2 = (0,react.useState)(null), arrowElement = ref2[0], setArrowElement = ref2[1];
    var ref3 = (0,usePopper/* usePopper */.D)(buttonElement, popperElement, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            {
                name: "offset",
                enabled: true,
                options: {
                    offset: [
                        0,
                        5
                    ]
                }
            }, 
        ]
    }), styles = ref3.styles, attributes = ref3.attributes;
    // Hover logic
    var ref4 = (0,react.useState)(false), openDropdown = ref4[0], setOpenDropdown = ref4[1];
    var ref5 = (0,react.useState)(false), mouseOverButton = ref5[0], setMouseOverButton = ref5[1];
    var ref6 = (0,react.useState)(false), mouseOverMenu = ref6[0], setMouseOverMenu = ref6[1];
    var timeoutDuration = 50;
    var timeoutButton;
    var timeoutMenu;
    var onMouseEnterButton = function() {
        clearTimeout(timeoutButton);
        setOpenDropdown(true);
        setMouseOverButton(true);
    };
    var onMouseLeaveButton = function() {
        timeoutButton = setTimeout(function() {
            return setMouseOverButton(false);
        }, timeoutDuration);
    };
    var onMouseEnterMenu = function() {
        clearTimeout(timeoutMenu);
        setMouseOverMenu(true);
    };
    var onMouseLeaveMenu = function() {
        timeoutMenu = setTimeout(function() {
            return setMouseOverMenu(false);
        }, timeoutDuration);
    };
    var show = openDropdown && (mouseOverMenu || mouseOverButton);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                ref: setButtonElement,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: function() {
                        return setOpenDropdown(!openDropdown);
                    },
                    onMouseEnter: onMouseEnterButton,
                    onMouseLeave: onMouseLeaveButton,
                    className: classnames_default()("px-8 leading-4 tracking-widest text-white uppercase h-full py-4", "".concat(show || linkPathnames.includes(router.asPath) ? "font-bold" : "font-medium")),
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                ref: popperElementRef,
                style: styles.popper
            }, attributes.popper), {
                className: "z-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                    show: show,
                    unmount: false,
                    enter: "transition ease-out duration-100",
                    enterFrom: "transform opacity-0 scale-95",
                    enterTo: "transform opacity-100 scale-100",
                    leave: "transition ease-in duration-75",
                    leaveFrom: "transform opacity-100 scale-100",
                    leaveTo: "transform opacity-0 scale-95",
                    beforeEnter: function() {
                        return setPopperElement(popperElementRef.current);
                    },
                    afterLeave: function() {
                        return setPopperElement(null);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Panel */.J.Panel, {
                        onMouseEnter: onMouseEnterMenu,
                        onMouseLeave: onMouseLeaveMenu,
                        unmount: false,
                        className: "rounded bg-dawnDark-550",
                        onClick: function() {
                            return setOpenDropdown(!openDropdown);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                ref: setArrowElement,
                                style: styles.arrow,
                                className: "before:rounded before:-top-2 before:w-5 before:h-5 before:transform before:rotate-45 before:bg-dawnDark-550 before:absolute"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col p-4 text-white",
                                children: children
                            })
                        ]
                    })
                })
            }))
        ]
    });
}

// EXTERNAL MODULE: ./public/navbar-get-started.svg
var navbar_get_started = __webpack_require__(42385);
;// CONCATENATED MODULE: ./components/Navbar/NavbarMenuDesktop.tsx







function NavbarMenuDesktop() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex justify-center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center justify-between flex-1 px-10 py-5 max-w-9xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLogo, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuDesktopDropdown, {
                            title: "About",
                            linkPathnames: navbarLinksAboutPathnames,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksAbout, {
                                linkClassName: "px-4 py-2 text-lg leading-8 rounded font-inter whitespace-nowrap hover:bg-dawnDark-400 hover:bg-opacity-70"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuDesktopDropdown, {
                            title: "Our Science",
                            linkPathnames: navbarLinksPagesPathnames,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksPages, {
                                linkClassName: "px-4 py-2 text-lg leading-8 rounded font-inter whitespace-nowrap hover:bg-dawnDark-400 hover:bg-opacity-70"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "font-medium leading-4 tracking-widest text-white uppercase",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLinksDefault, {
                                linkClassName: "px-8 py-4"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* Link */.r, {
                            href: "/questionnaire",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                className: "ml-8",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: navbar_get_started/* default */.Z,
                                    alt: "Get started"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./components/Navbar/Navbar.tsx



function Navbar(param) {
    var className = param.className, ctaInHeader = param.ctaInHeader, ctaText = param.ctaText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block lg:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuMobile, {
                    ctaInHeader: ctaInHeader,
                    ctaText: ctaText
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "hidden lg:block",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMenuDesktop, {})
            })
        ]
    });
};


/***/ })

}]);